import { useState } from "react";
import "./Login.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../../Redux/apiCalls/apiCalls";
import { ToastContainer, toast } from "react-toastify";

export const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userData, setUserData] = useState({
    email: "",
    password: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const result = await login(dispatch, userData);

      if (!result?.success) {
        toast.error(result?.message || "Identifiants incorrects", {
          style: { marginTop: "70px", height: "70px" },
          theme: "light",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        return;
      }

      toast.success("Connecté avec succès !", {
        style: { marginTop: "70px", height: "70px" },
        theme: "light",
        autoClose: 1200,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      setTimeout(() => {
        navigate("/");
      }, 1200);
    } catch (err) {
      toast.error("Erreur de connexion", {
        style: { marginTop: "70px", height: "70px" },
        theme: "light",
        autoClose: 2000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <h1 className="login-title">Connexion</h1>

      <div className="signup-container">
        <form className="signup-form" onSubmit={handleLogin}>
          <input
            type="email"
            name="email"
            placeholder="E-mail"
            value={userData.email}
            onChange={handleInputChange}
            required
          />

          <input
            type="password"
            name="password"
            placeholder="Mot de passe"
            value={userData.password}
            onChange={handleInputChange}
            required
          />

          <button type="submit" disabled={isLoading}>
            {isLoading ? "Connexion..." : "Se connecter"}
          </button>

          <p>
            <Link to="/forgot-password">Mot de passe oublié ?</Link>
          </p>

          <p>
            Ajouter un utilisateur ?{" "}
            <Link to="/add-user">Créer un compte</Link>
          </p>
        </form>
      </div>

      <ToastContainer position="top-right" />
    </div>
  );
};